import { useMutation } from "@tanstack/react-query";
import { type AxiosPromise } from "axios";
import { Modal } from "components";
import { Loading } from "components/panels";
import React, { useState } from "react";
import { Button, Message } from "semantic-ui-react";
import { useApi } from "utilities/hookutils";

interface Props {
  mainArea: server.dto.MainAreas
  api: () => AxiosPromise<any>
  onClose: () => void
  title: string
  hasSelectedValue: boolean
  action: server.dto.MySelectionActions
}

const formMinHeight = 144; // Modal min height (250) - header height (46) - padding (30 + 30)

const BaseModal = (props: React.PropsWithChildren<Props>) => {
  const warningApi = useApi(async () => window.CoreApi.MySelection.Warning({ mainArea: props.mainArea, action: props.action }), ["mySelectionWarning"]);
  const applyChangeApi = useMutation(props.api, {
    retry: false
  });
  const [message, setMessage] = useState<string | null>(null);

  const onFormSubmit = async (e) => {
    e.preventDefault();
    const response = await applyChangeApi.mutateAsync();
    setMessage(response.data);
  };

  const buttonLabel = props.action === "delete" ? RESX.Buttons.btnDelete : RESX.Buttons.btnSave;
  const buttonColor = props.action === "delete" ? "red" : null;

  return <Modal
    isOpen
    handleClose={props.onClose}
    title={props.title}
  >
    {message
      ? (
        <form className="flex-column" style={{ minHeight: formMinHeight }}>
          <Message color="green" style={{ flexShrink: 0 }}>
            {message}
          </Message>
          <div className="grow1" />
          <div className="flex justify-end">
            <div className="grow1"></div>
            <div>
              <Button onClick={props.onClose} primary>
                {RESX.Buttons.BtnOk}
              </Button>
            </div>
          </div>
        </form>
      )
      : (
        <form className="flex-column" style={{ minHeight: formMinHeight }}>
          <Message color="red" style={{ flexShrink: 0 }}>
            {warningApi.data}
            {warningApi.isLoading && <Loading />}
          </Message>

          {applyChangeApi.isError && <Message className="margin-top" color="red">
            {RESX.GeneralLabels.SomethingUnexpectedHappened}
          </Message>}

          <div className="margin-top grow1">
            {props.children}
          </div>

          <div className="flex margin-top">
            <div className="grow1"></div>
            <div>
              <Button
                onClick={onFormSubmit}
                disabled={applyChangeApi.isLoading || !props.hasSelectedValue}
                loading={applyChangeApi.isLoading}
                color={buttonColor}
                primary
              >
                {buttonLabel}
              </Button>
            </div>
          </div>
        </form>
      )}
  </Modal>;
};

export default BaseModal;
